import SocialLoopMetricCard from './SocialLoopMetricCard';
import {
  BODY2_DEFAULT,
  formatCountOfTotal,
  formatPercentDisplay,
  normalizeMetric,
} from '../utils/metricFormatters';

const ReplyRate = ({ metrics }) => {
  const stat = normalizeMetric(metrics?.replyRate);
  const percentageText = stat ? formatPercentDisplay(stat.percentage) : '0%';
  const body2Text = stat
    ? `${formatCountOfTotal(stat.count, stat.totalCount)} in selected period`
    : BODY2_DEFAULT;

  return <SocialLoopMetricCard title="Reply Rate" value={percentageText} description={body2Text} />;
};

export default ReplyRate;
